export default __webpack_public_path__ + "static/instagram-f0241fa153740b6ab74dae92fb8e5d3a.png";